import React from 'react';
import { connect } from 'react-redux';
import { updateAvatarLocal } from 'registration/creative/ducks';
import { updateUser } from 'common/ducks/user';
import Avatar from 'registration/creative/components/avatar';

const mapStateToProps = ({user, creativeRegistration: {avatar}}) => ({
  avatar,
  user
})

export default connect(mapStateToProps, {
  updateLocal: updateAvatarLocal,
  updateUser
})(Avatar);



// WEBPACK FOOTER //
// ./registration/creative/containers/avatar.jsx